import { FormControlLabel, Stack, Switch } from '@mui/material'
import { ChangeEvent, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import LoanCalendarTablePrimaryActions from './LoanCalendarTablePrimaryActions'
import LoanCalendarTableSecondaryActions from './LoanCalendarTableSecondaryActions'

interface Props {
  showMore: boolean
  onShowMoreChange: (value: boolean) => void
}

const LoanCalendarTableToolbar = ({ showMore, onShowMoreChange }: Props) => {
  const { t } = useTranslation()

  const handleShowMoreChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => onShowMoreChange(event.target.checked),
    [onShowMoreChange],
  )

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      flexWrap="wrap"
      gap={1}
      sx={{ flexGrow: 1 }}
    >
      <LoanCalendarTablePrimaryActions />
      <Stack direction="row" alignItems="center" gap={1}>
        <FormControlLabel
          control={<Switch checked={showMore} onChange={handleShowMoreChange} />}
          label={t('loan.payment.detail')}
        />
        <LoanCalendarTableSecondaryActions />
      </Stack>
    </Stack>
  )
}

export default LoanCalendarTableToolbar
